<div class="row mb-1">
  <div class="col-md-12">
    Descrição da atividade    
    <textarea  [disabled]="visualizar" rows="3" id="txtDescricaoAtividade"
      class="form-control form-control-sm" [(ngModel)]="descricaoAtividade" maxlength="255">
    </textarea>
  </div>
</div>
<div class="row mb-1">
  <div class="col-md-12">
    Responsável pela atividade
    <textarea  [disabled]="visualizar" rows="3" id="txtResponsavel" 
      class="form-control form-control-sm" [(ngModel)]="nomeResponsavel" maxlength="255">
    </textarea>
  </div>
</div>
<div class="row mb-1">
  <div class="col-md-12">
    Como é realizada
    <textarea  [disabled]="visualizar" rows="3" id="txtProcesso" 
    class="form-control form-control-sm" [(ngModel)]="descricaoRealizacao" maxlength="555">
    </textarea>
  </div>
</div>
  <div [hidden]="visualizar">
    <div class="row mb-2">
      <div class="col-md-8"></div>
      <div class="col-md-4" style="text-align: right;">
        <button type="button" class="btn btn-primary btn-sm" (click)="novo()">
          <i class="fas fa-file"></i> Nova
        </button>
        &nbsp;
        <button type="button" class="btn btn-success btn-sm" (click)="adicionar()">
          <i class="fas fa-plus"></i> {{ getNameBtn() }}
        </button>
      </div>
    </div>
  </div>

<div class="row mb-1">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-12">
        <h4>Lista de Atividades Auditadas</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <app-grid-abas-matriz-risco [dados]="objPrincipal.atividades"
          [listColunas]="listColunas"
          [visualizar]="this.visualizar"
          [siglaPosicao]="'AT'"
          (btnRemover)="remover($event)"
          (btnEditar)="editar($event)"></app-grid-abas-matriz-risco>
      </div>
    </div>
  </div>
</div>
